import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';
import { IOption } from '@shared';
import { environment } from 'src/environments/environment';
import { TransferState, makeStateKey } from '@angular/platform-browser';
import { isPlatformServer } from '@angular/common';

const ACTIVITIES_KEY = makeStateKey<IOption[] | null>('activities');

@Injectable({
  providedIn: 'root',
})
export class ActivitiesService {
  constructor(
    private _http: HttpClient,
    private _transferState: TransferState,
    @Inject(PLATFORM_ID) private _platformId: Object,
  ) {}

  getActivities(): Observable<any> {
    const activities: IOption[] | null = this._transferState.get<IOption[] | null>(ACTIVITIES_KEY, null);

    this._transferState.remove(ACTIVITIES_KEY);
    if (activities) return of(activities);

    return this._http.get(`${environment.apiUrl}/account/spheres/`).pipe(
      tap((activities: any) => {
        if (isPlatformServer(this._platformId)) {
          this._transferState.set<IOption[] | null>(ACTIVITIES_KEY, activities);
        }
      }),
    );
  }
}
